import React from 'react';
import { Grid } from 'semantic-ui-react';
// import {Redirect} from 'react-router-dom';
// import {graphql} from 'react-apollo';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';

//utils
import queries from '../utils/queries'

//components
import Signin from './login/signin';

const styles ={
  grid: {
    height: '100%',
    width: '800px',
    margin: '0 auto',
  },
  box:{
    background: 'linear-gradient(#FE0000, #FE0000)', border: '1px solid #FE0000',
    // border: '1px solid #e6e6e6',
    textAlign: 'center',
    marginBottom: '1em',
    marginTop: '4em',
    padding: '1em',
  },
  label:{
    color: 'white',
    textAlign: 'left',
  },
  confirmar:{
    background: 'linear-gradient(#FEC500, #FEC500)',
    border: '0px',
    color: '#FE0000',
    fontWeight: 'bold',
  },
  input:{
    background: 'linear-gradient(white, white )',
    border: '0px',
    color: 'white',
  },
}

class Login extends React.Component{
  state = {
    argsUsuario: {},
    errorUsuario: []
  }

  handleLogin = async (ev, args)=>{
// const response = await this.props.login({
// variables: {
//     claveDeAcceso: "wilson",
//     email: "wilson@hotmail.com",
//     _id: "5af6d775ab98252fd8a7bb82",
//     descrPerfil: "Administrador",
//     nombreUsuario: "WIlson Martinez"
// }
// });

    if(!args.email||!args.claveDeAcceso) {
      const argsUsuario = this.state.argsUsuario
      const errors = [];
      if(!args.email){
        argsUsuario['email'] = "";
        errors.push({path: 'email', message: "Debe escribir el correo electrónico"});
      }
      if(!args.claveDeAcceso){
        argsUsuario['claveDeAcceso'] = "";
        errors.push({path: 'Clave de acceso', message: "Debe escribir la clave de acceso"});
      }
      this.setState({argsUsuario});
      this.setState({errorUsuario: errors})
    }else{
      const response = await this.props.login({
        variables: args
      });
      const {errors, success, token, ok} = response.data.login
      // console.log(success)
      if(!success){
        this.setState({errorUsuario: errors})
      }else{
        localStorage.setItem('token', token)
        localStorage.setItem('userLogin', args.email)
        let descrEmpresaUAIni = ok, descrEmpresaUA="Todas..."

        // const listaEmp = this.props.allEmpresa.allEmpresa

        let listaEmp=''
        if (this.props.allEmpresa.allEmpresa){
          listaEmp = this.props.allEmpresa.allEmpresa
        }
        // console.log(listaEmp)
        listaEmp.forEach((elemento, _id) => {
          if(elemento.descrEmpresa===descrEmpresaUAIni){
            descrEmpresaUA = elemento.descrEmpresa
          }
        })
        localStorage.setItem('Empresa', descrEmpresaUA)
        let argsEncr = {valor: args.email, comparar: "no"}
        let response = await this.props.encriptar({
          variables: argsEncr
        });

        const {encriptado} = response.data.encriptar;
        localStorage.setItem('token1', encriptado)
        argsEncr = {valor: descrEmpresaUA, comparar: "no"}
        response = await this.props.encriptar({
          variables: argsEncr
        });

        if(argsEncr){
          const {encriptado} = response.data.encriptar;

          localStorage.setItem('token2', encriptado)
        }

        this.props.history.push("/Home")
      }
    }
  }

  handleChange = (ev, input)=>{
      const argsUsuario = this.state.argsUsuario
      argsUsuario[input.name] = input.value
      this.setState({argsUsuario});
      // console.log(this.state.argsUsuario)
  }
  
  render(){
//         console.log(localStorage.getItem('userLogin'))
// console.log(localStorage.getItem('token'))
      const {argsUsuario, errorUsuario} = this.state;
      console.log("login")
      // localStorage.removeItem('token');
      // localStorage.removeItem('userLogin')
      return (
          <div className="ui grid container">
              <Grid verticalAlign='middle' columns = {2} centered style={styles.grid}>
                  <Grid.Row>
                      {/* <Grid.Column>
                          <Image src="images/login.png" alt="Login" fluid/>
                      </Grid.Column> */}
                      <Grid.Column>
                          <Signin styles={styles} handleSubmit={this.handleLogin} handleChange={this.handleChange} args={argsUsuario} errors={errorUsuario}/>
                      </Grid.Column>
                  </Grid.Row>
              </Grid>
      </div>
      )
  }
}

// export default graphql(queries.mutation.login)(Login)
// // export default graphql(queries.mutation.createUsuario)(Login)


export default compose(
  graphql(queries.query.allEmpresa, {name:'allEmpresa'}),

  graphql(queries.mutation.login, {name:'login'}),
  graphql(queries.mutation.encriptar, {name:'encriptar'}),
)(Login)
